import React, {useCallback} from 'react';
import {WidgetProps, usePanorama} from '@wix/yoshi-flow-editor';
import {withSlotsPlaceholders} from '@wix/widget-plugins-ooi';
import {IControllerProps} from '../../../types/app.types';
import {ControllerContext} from './ControllerContext';
import ThankYouPageApp from './ThankYouPageApp/ThankYouPageApp';

export default withErrorBoundary(withSlotsPlaceholders(ThankYouPageAppRoot));

function ThankYouPageAppRoot(controllerProps: WidgetProps<IControllerProps>) {
  return (
    <ControllerContext value={controllerProps}>
      <ThankYouPageApp />
    </ControllerContext>
  );
}

class ErrorBoundary extends React.Component<
  React.PropsWithChildren<{
    onError: (error: unknown, errorInfo: unknown) => void;
  }>
> {
  /* istanbul ignore next */
  public componentDidCatch(error: unknown, errorInfo: unknown) {
    this.props.onError(error, errorInfo);
  }

  public render() {
    return this.props.children;
  }
}

function withErrorBoundary<P extends Record<string, unknown>>(Component: React.ComponentType<P>): React.FC<P> {
  return function WithErrorBoundary(props: P) {
    const panorama = usePanorama();

    const onError = useCallback(
      /* istanbul ignore next */
      (error: unknown, errorInfo: unknown) => {
        panorama
          .logger()
          .error('Root widget component did catch', {errorMessage: (error as Error).message, error, errorInfo});
      },
      [panorama]
    );

    return (
      <ErrorBoundary onError={onError}>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
}
